import React from "react";
import { DateInput } from "./DateInput";
import { FormControl, Stack } from "@primer/react";
import { MonthYearInput } from "./MonthYearInput";

interface DateRangeInputProps {
  fromDate: string;
  toDate: string;
  onFromDateChange: (date: string) => void;
  onToDateChange: (date: string) => void;
  className?: string;
  disabled?: boolean;
  error?: boolean;
  mode?: 'full' | 'monthYear';
}

export const DateRangeInput: React.FC<DateRangeInputProps> = ({
  fromDate,
  toDate,
  onFromDateChange,
  onToDateChange,
  className = "",
  disabled = false,
  error,
  mode = 'full'
}) => {
  return (
    <Stack direction="horizontal">
      <FormControl required key="from">
        <FormControl.Label className="invisible h-0"></FormControl.Label>
        {mode === 'full' && <DateInput
          value={fromDate}
          onChange={onFromDateChange}
          type="from"
          disabled={disabled}
          maxDate={toDate || undefined}
          className="!w-[140px]"
        />
        }
        {mode === 'monthYear' && <MonthYearInput
          value={fromDate}
          onChange={onFromDateChange}
          type="from"
          disabled={disabled}
          maxDate={toDate || undefined}
          className="!w-[140px]"
        />
        }
        {error && (
          <FormControl.Validation
            variant="error"
            className="invisible h-0"
          ></FormControl.Validation>
        )}
      </FormControl>

      <FormControl required key="to">
        <FormControl.Label className="invisible h-0"></FormControl.Label>
        {mode === 'full' && <DateInput
          value={toDate}
          onChange={onToDateChange}
          type="to"
          disabled={disabled}
          minDate={fromDate || undefined}
          className="!w-[140px]"
        />}
        {mode === 'monthYear' && <MonthYearInput
          value={toDate}
          onChange={onToDateChange}
          type="to"
          disabled={disabled}
          minDate={fromDate || undefined}
          className="!w-[140px]"
        />}
        {error && (
          <FormControl.Validation
            variant="error"
            className="invisible h-0"
          ></FormControl.Validation>
        )}
      </FormControl>
    </Stack>
  );
};
